import React from 'react';
import { css, cx } from 'emotion';
import { pillarPalette } from '@frontend/lib/pillars';
const contributorImage = css `
	border-radius: 100%;
	object-fit: cover;
	height: 100%;
	width: 100%;
`;
const pillarBackground = (pillar = 'opinion') => css `
		background-color: ${pillar === 'opinion'
    ? pillarPalette[pillar].main
    : pillarPalette[pillar].bright};
	`;
export const Avatar = ({ imageSrc, imageAlt, pillar }) => {
    return (React.createElement("img", { src: imageSrc, alt: imageAlt, className: cx(pillarBackground(pillar), contributorImage) }));
};
